import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { addAgeGroup } from 'app/redux/store/features/ageGroups'
import { defaultAgeGroup } from './defaultAgeGroup'
import AddAgeGroupForm from './AddAgeGroupForm'

const AddAgeGroup = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { enqueueSnackbar } = useSnackbar()
    const [AgeGroupData] = useState({ ...defaultAgeGroup })
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { loading, error } = useSelector((state) => state.ageGroups)

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)
        if (error) handleError(error)
        else {
            enqueueSnackbar('Age Group added successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/definitions/age-group')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onAddAgeGroup = async () => {
        setApiCallInProgress(true)
        dispatch(addAgeGroup({ ...AgeGroupData }))
    }

    return (
        <React.Fragment>
            <AddAgeGroupForm AgeGroupData={AgeGroupData} addAgeGroup={onAddAgeGroup} />
        </React.Fragment>
    )
}

export default AddAgeGroup
